import React from 'react'

export type ChevronDirection = 'down' | 'up' | 'left' | 'right'

export interface ChevronProps {
  direction?: ChevronDirection;
  className?: string;
}

export const Chevron = ({ direction = 'down', className = '' }: ChevronProps): JSX.Element => {
  const rotations: Record<ChevronDirection, string> = {
    down: 'rotate(180deg)',
    up: 'rotate(0deg)',
    left: 'rotate(90deg)',
    right: 'rotate(-90deg)',
  }

  const style = {
    transform: rotations[direction],
    transition: 'transform 0.2s ease',
    transformOrigin: 'center',
  }

  return (
    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={style} className={className}>
      <path
        stroke="currentColor"
        strokeWidth="1.75"
        fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  )
}
